import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    totalObligationManager: Yup.string().required(
        'مجموع تعهدات مدیر الزامی می باشد'
    ),
    paidObligationManager: Yup.string().required(
        'تعهدات پرداخت شده مدیر الزامی می باشد'
    ),
})
